/**
 * The masked card number from a card ({ data: {...} } include or the bare object), in the same shape
 * as the Card Transactions list: "5129 92** ****7631" (first6 grouped 4+2, middle masked, last4).
 * PCI: only the BIN (first6) and last4 are ever shown - never the middle digits / a full PAN, and each
 * field is reduced to its own digits so a malformed/legacy value can't leak through. Falls back to
 * "····<last4>" when there is no first6, and '' when there is no usable last4.
 * The brand is shown separately, as a <payarc-card-mark> logo.
 * Used by the global search results and the payment details card.
 */
export function maskedCardNumber(card: any): string {
  const c = card?.data ?? card;
  const last4raw = c?.last4digit == null ? '' : String(c.last4digit).replace(/\D/g, '');
  const last4 = last4raw.length >= 4 ? last4raw.slice(-4) : '';
  if (!last4) { return ''; }
  const first6 = (c?.first6digit == null ? '' : String(c.first6digit).replace(/\D/g, '')).slice(0, 6);
  return first6.length === 6
    ? first6.slice(0, 4) + ' ' + first6.slice(4) + '** ****' + last4
    : '····' + last4;
}
